import React from "react";
import { Container } from "react-bootstrap";

const Us = () => {
	return (
		<Container className="py-5 px-4 px-lg-0">
			<p className="text-justify">
				Somos una organización no gubernamental comprometida con promover la cultura de legalidad y el estado de derecho. Nuestro
				equipo esta conformado por socios y asociados que trabajamos día a día para ofrecer el mejor servicio comprometidos con la
				honestidad y la equidad en nuestra práctica, promoviendo y defendiendo los derechos humanos. ​ Somos Abogados apasionados
				del Derecho, especializados y con amplia experiencia en áreas del Derecho Penal, Fiscal, Administrativo y Amparo, así como
				en el área Civil, Mercantil y del Trabajo, siendo nuestro propósito consolidarnos en la región como una verdadera opción
				para nuestros clientes en servicios legales. ​ Además, desde el año 2018 hemos sido una plataforma que busca el
				enriquecimiento cultural y académico de la comunidad jurídica ofreciendo talleres enfocados en la litigación oral.
				Aumentando nuestro compromiso social ofreciendo calidad en cada capacitación buscando contribuir para que el sistema
				judicial tenga cada día intervinientes más capacitados que ayuden a que los procesos sean más ágiles y eficientes.
			</p>
		</Container>
	);
};

export default Us;
